import { Routes } from '@angular/router';
import { HomeComponent } from './phases/home/home.component';
import { AvailabilityComponent } from './phases/availability/availability.component';
import { ProfileComponent } from './phases/profile/profile.component';
import { Error404Component } from './phases/404/404.component';
import { ConfirmationComponent } from './phases/confirmation/confirmation.component';
import { HotelsComponent } from './phases/hotels/hotels.component';
import { DeeplinkHandlerComponent } from './components/deeplink-handler/deeplink-handler.component';
import { DeeplinkGeneratorComponent } from './components/deeplink-generator/deeplink-generator.component';
import { FindReservationComponent } from './phases/find-reservation/find-reservation.component';
import { PaymentSuccessComponent } from './phases/payment-success/payment-success.component';
import { PaymentCancelComponent } from './phases/payment-cancel/payment-cancel.component';
import { ClearcacheComponent } from './phases/clearcache/clearcache.component';
import { EmailpreviewComponent } from './phases/emailpreview/emailpreview.component';
import { EnabledebugComponent } from 'core-lib';
import { AvoineLoginCallbackComponent } from './phases/avoine-login-callback/avoine-login-callback.component';
import { AdminComponent } from './phases/admin/admin.component';


export const routes: Routes = [
    { path: 'home', component: HomeComponent, data: {reuseComponent: false} },
    { path: 'hotels', component: HotelsComponent, data: {reuseComponent: false} },
    { path: 'availability', component: AvailabilityComponent, data: {reuseComponent: false} },
    { path: 'profile', component: ProfileComponent,  data: {reuseComponent: false} },
    { path: 'confirmation', component: ConfirmationComponent,  data: {reuseComponent: false} },
    { path: 'find-reservation', component: FindReservationComponent,  data: {reuseComponent: false} },
    { path: 'deeplink', component: DeeplinkHandlerComponent, data: {reuseComponent: false} },
    { path: 'deeplink-generator', component: DeeplinkGeneratorComponent, data: {reuseComponent: false} },
    { path: 'paymentsuccess', component: PaymentSuccessComponent, data: {reuseComponent: false} },
    { path: 'paymentcancel', component: PaymentCancelComponent, data: {reuseComponent: false} },
    { path: 'avoine-login-callback', component: AvoineLoginCallbackComponent, data: {reuseComponent: false} },
    { path: 'clearcache', component: ClearcacheComponent, data: {reuseComponent: false} },
    { path: 'clear', component: ClearcacheComponent, data: {reuseComponent: false} },
    { path: 'preview', component: EmailpreviewComponent, data: {reuseComponent: false} },
    { path: 'debug', component: EnabledebugComponent, data: {reuseComponent: false} },
    { path: 'admin', component: AdminComponent, data: {reuseComponent: false} },
    
    { path: 'restaurant', loadChildren: () => import('./features/table-reservation/restaurant.routes').then(m => m.restaurantRoutes) },

    { path: '',   redirectTo: '/home', pathMatch: 'full' }, // redirect to `first-component`
    { path: '**', component: Error404Component },
];
